import styled from '@emotion/styled';

import { breakPoint } from 'shared/styles';
import TechnologyItem from './TechnologyItem';

const technologies = [
  {
    title: '아트웍 레이아웃 분석 기술',
    description:
      'PDF 형식의 Artwork은 이미지로 변환된 후 전처리 과정을 거쳐, 자체 개발한 Layout Analysis 모델을 통해 텍스트, 심볼, 테이블 등 구성 요소의 위치와 계층 구조를 정밀하게 분석합니다. 이를 통해 시각적 배치와 정보 구조까지 고려한, 인허가 문구 검토에 최적화된 입력 데이터를 생성합니다.',
    imageFilename: 'tech-c-1.png',
  },
  {
    title: '광학문자인식',
    description:
      '이미지 인식 기술을 통해 추출한 Artwork 내 텍스트 영역의 좌표를 기반으로 광학문자인식(OCR)을 수행합니다.\nOCR을 통해 얻어진 텍스트는 화장품 도메인에 특화된 대규모 언어 모델(LLM)의 입력값으로 사용됩니다.',
    imageFilename: 'tech-c-2.png',
  },
  {
    title: '대규모 언어 모델',
    description:
      'CDRI의 추론 엔진은 화장품 인허가에 특화된 대규모 언어 모델 기반의 agentic AI로, 텍스트와 레이아웃 등 복합 정보를 종합적으로 분석합니다.\n이를 통해 문구의 규제 적합성을 정밀하게 판단하고, 인허가 검토와 개선을 효과적으로 지원합니다.',
    imageFilename: 'tech-c-3.png',
  },
  {
    title: 'CertiPT',
    description:
      'CertiPT는 LLM과 멀티에이전트 기술을 활용해 인허가에 필요한 원천 서류를 프라이빗 보안 클라우드에서 분류, 분석하는 솔루션입니다.\n여러 초거대 인공지능 모델이 협업해 인허가 원천 서류를 분석하고, 서류상의 오탈자 및 논리적 오류를 사전 탐지 후 인허가 담당자에게 보고하여 신속하고 정밀한 서류 작업을 돕습니다. 또한 실무 담당자가 의사 결정을 빠르게 내릴 수 있도록 다음 액션 아이템을 제안하고, 담당자별 업무 분담 및 피드백 내역을 체계적으로 관리할 수 있도록 돕습니다.',
    imageFilename: 'tech-c-4.png',
  },
  {
    title: '성분 사전',
    description:
      '화장품 성분에 대한 체계적인 사전 시스템을 구축하였습니다. ICID, 화장품성분사전, Cosing 등 다양한 국가에서 사용되고 있는 성분들에 정보를 취합하였습니다. 성분들의 다양한 성분명, CAS NO, Function 등에 많은 정보를 손 쉽게 관리할 수 있습니다. 또한 다양한 국가 및 기관 규제를 해석하고 성분들의 성분, 색소, 알러지, 제품 타입 등에 맞는 규제정보 효율적으로 관리할 수 있습니다.',
    imageFilename: 'tech-c-5.png',
  },
];

const SectionC = () => {
  return (
    <Container>
      <TechnologyList>
        {technologies.map((technology) => (
          <TechnologyItem key={technology.title} {...technology} />
        ))}
      </TechnologyList>
    </Container>
  );
};

export default SectionC;

const Container = styled.section`
  position: relative;
  padding: 200px 0 0 0 !important;

  @media screen and ${breakPoint.TABLET_TO_LARGE_DEVICE} {
    padding: 120px 24px !important;
  }
  @media screen and ${breakPoint.MOBILE} {
    padding: 80px 24px !important;
  }
`;

const TechnologyList = styled.section`
  width: 1200px;
  margin: 0 auto;

  @media screen and ${breakPoint.LARGE_DEVICE} {
    width: 100%;
  }
`;
